// please use this pattern for all mixpanel events:
// "FEATURE__DETAILS_ABOUT_THE_EVENT" notice the double underscore after the feature name

// event names (the string value) should be easy to understand and describe why they matter in the users flow regarding the feature they are using
// try to describe what is happening in a human readable way
// use words like "navigated", "contacted", "sent", "closed" etc instead of just "clicked"

// event constant names do not need to be as descriptive, they are only dev facing

// Dashboard Overview
const DASHBOARD_OVERVIEW__LANDED_ON_PAGE =
  'Dashboard Overview - Landed on dashboard overview page';
const DASHBOARD_OVERVIEW__CLICKED_ON_CURRENT_AI_WITH_QUESTION =
  'Dashboard Overview - Clicked on link to current AI with question';
const DASHBOARD_OVERVIEW__CLICKED_ON_ASK_MEGAN_WITH_QUESTION =
  'Dashboard Overview - Clicked on link to ask Megan with question';

// Workday Modal Log Work Hours
const WORKDAY_HOURS__NAVIGATED_TO_WORKDAY =
  'Workday hours - Navigated to workday url';

const WORKDAY_HOURS__NAVIGATED_TO_WORKDAY_FROM_ERROR_MESSAGE =
  'Workday hours - Navigated to workday url from error message';

const WORKDAY_HOURS__CLICKED_DASHBOARD_CLOCK_WORK_HOURS_BUTTON =
  'Workday hours - Clicked dashboard clock work hours button';

const REFERRAL_CENTER__OPENED_ROW_ACTIONS_MENU =
  'Referral Center - Opened row actions menu';

export {
  DASHBOARD_OVERVIEW__LANDED_ON_PAGE,
  DASHBOARD_OVERVIEW__CLICKED_ON_CURRENT_AI_WITH_QUESTION,
  DASHBOARD_OVERVIEW__CLICKED_ON_ASK_MEGAN_WITH_QUESTION,
  WORKDAY_HOURS__NAVIGATED_TO_WORKDAY,
  WORKDAY_HOURS__NAVIGATED_TO_WORKDAY_FROM_ERROR_MESSAGE,
  WORKDAY_HOURS__CLICKED_DASHBOARD_CLOCK_WORK_HOURS_BUTTON,
  REFERRAL_CENTER__OPENED_ROW_ACTIONS_MENU,
};
